import axios from "axios";

export function distRuleFundsCheck(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/distRuleFundsCheck`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        console.error("Error response from server:", err.response.data);
        console.error("Status code:", err.response.status);
        console.error("Headers:", err.response.headers);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Error setting up request:", err.message);
      }

      console.error("Error getting distribution rule logs:", err);

      throw err;
    });
}

export function scheduleActivRule(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/scheduleActivRule`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        console.error("Error response from server:", err.response.data);
        console.error("Status code:", err.response.status);
        console.error("Headers:", err.response.headers);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Error setting up request:", err.message);
      }

      console.error("Error getting distribution rule logs:", err);

      throw err;
    });
}

export function getWhatsappTemplates(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0]?.signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  const apiUrl = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getWhatsappTemplates`;
  return axios
    .put(apiUrl, qData, {
      headers: headers,
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function getDistRuleLogs(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getDistRuleLogs`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

export function getDetailedDistRuleLogs(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getDetailedDistRuleLogs`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

export function verifyWhatsAppImage(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/uploadTemplateImage`,
      qData,
      { headers }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}
